<script lang="ts">
    import { onMount } from 'svelte'
    import { Appointment } from '../../modules/schedulerApi/appointments/appointment'
    import { AppointmentStatus } from '../../modules/schedulerApi/appointments/appointments.enum'
    import { AppointmentsRepository } from '../../modules/schedulerApi/appointments/appointments.repository'
    import { AppointmentsService } from '../../modules/schedulerApi/appointments/appointments.service'
    import type { ChangeStatusDto } from '../../modules/schedulerApi/appointments/dto/change-status.dto'
    import dayjs from 'dayjs'
    import utc from 'dayjs/plugin/utc'
    import _isToday from 'dayjs/plugin/isToday'
    import _isTomorrow from 'dayjs/plugin/isTomorrow'
    import { ServicesRepository } from '../../modules/posApi/services/services.repository'
    import { ServicesService } from '../../modules/posApi/services/services.service'
    dayjs.extend(utc)
    dayjs.extend(_isToday)
    dayjs.extend(_isTomorrow)

    let appointmentsR = new AppointmentsRepository()
    let appointmentsS = new AppointmentsService(appointmentsR)

    let servicesR = new ServicesRepository()
    let servicesS = new ServicesService(servicesR)

    let step = 0
    let appointment: Appointment = new Appointment()
    let personId = null
    let services = ''
    let day = ''

    onMount(async () => {
        await load()
    })

    async function load() {
        //todo
        const urlParams = new URLSearchParams(window.location.search)
        personId = urlParams.get('u')
        if (!personId) {
            step = 9
            return
        }
        const time = urlParams.get('t')
        appointment = await appointmentsS.getNextAppointmentFromPerson(personId, time || null)
        if (!appointment) {
            step = 9
            return
        }
        console.log('app', appointment)
        window.api.users.statistics.tickPublicOnce(appointment.companyId, 'pub.agenda.open')
        if (appointment.status === AppointmentStatus.agendamento_confirmado) {
            step = 7 // entre em contato
            return
        }
        if (appointment.status != AppointmentStatus.agendamento_criado) {
            step = 8
            return
        }
        const serviceArray: any[] = await servicesS.getServiceNames({ companyId: appointment.companyId, strict: true })
        services = ''
        for (const item of appointment.items) {
            if (services) services += ', '
            services += serviceArray.find((el) => el.serviceId === item.serviceId)?.name
        }
        day = dayjs(appointment.start).format('DD/MM/YYYY HH:mm')
        if (dayjs(appointment.start).utc().isTomorrow()) {
            day += ' (amanhã)'
        }
        if (dayjs(appointment.start).utc().isToday()) {
            day += ' (hoje)'
        }
        step = 1
    }

    async function appointmentConfirm() {
        let dto: ChangeStatusDto = {
            status: AppointmentStatus.agendamento_confirmado,
        }
        await appointmentsS.publicChangeStatus(appointment.personId, appointment.appointmentId, dto)
        window.api.users.statistics.tickPublic(appointment.companyId, 'pub.agenda.confirm')
        step = 3 // confirm
    }

    async function appointmentCancel() {
        let dto: ChangeStatusDto = {
            status: AppointmentStatus.agendamento_cancelado_usuario,
        }
        await appointmentsS.publicChangeStatus(appointment.personId, appointment.appointmentId, dto)
        window.api.users.statistics.tickPublic(appointment.companyId, 'pub.agenda.cancel')
        step = 2 // cancel
    }
</script>

<div class="root">
    <div class="-content">
        {#if step === 0}
            <div class="text-center">Aguarde...</div>
        {/if}

        {#if step === 1}
            <div class="appointment">
                <div class="-title">Você possui um agendamento:</div>
                <div class="item">
                    <div class="label">Data:</div>
                    <div class="value">{day}</div>
                </div>
                <div class="item">
                    <div class="label">Serviço:</div>
                    <div class="value">{services}</div>
                </div>
                <label class="text-center mt-5 mb-4" for="">Você confirma sua presença?</label>
                <div class="text-center">
                    <button on:click={appointmentCancel} class="btn btn-secondary">&nbsp;&nbsp;&nbsp;&nbsp;Não&nbsp;&nbsp;&nbsp;&nbsp;</button
                    >&nbsp;&nbsp;&nbsp;&nbsp;
                    <button on:click={appointmentConfirm} class="btn btn-primary">&nbsp;&nbsp;&nbsp;&nbsp;Sim&nbsp;&nbsp;&nbsp;&nbsp;</button>
                </div>
            </div>
        {/if}
        {#if step === 2}
            <div class="text-center">
                Cancelamento enviado.<br />Por gentileza entre em contato para reagendarmos seu horário.
            </div>
        {/if}
        {#if step === 3}
            <div class="text-center">Agendamento confirmado com sucesso.<br />Aguardamos sua presença.</div>
        {/if}
        {#if step === 7}
            <div class="text-center">Seu agendamento já foi confirmado.<br />Caso precise alterar entre em contato.</div>
        {/if}
        {#if step === 8}
            <div class="text-center">Seu agendamento foi cancelado.<br />Caso precise alterar entre em contato.</div>
        {/if}
        {#if step === 9}
            <div class="text-center">Não há agendamentos a serem confirmados no momento.</div>
        {/if}
    </div>
    <div class="-footer">
        <img src="/img/logo_black.png" alt="" />
        <a href="https://zandu.com.br/?utm_source=app_confirmation" target="_blank">Zandu - Gestão e confirmação de agendas</a>
    </div>
</div>

<style>
    .root {
        max-width: 470px;
        font-size: 20px;
        font-weight: 400;
        padding: 32px 8px 16px 8px;
        padding-top: 15%;
        display: flex;
        flex-direction: column;
        margin-left: auto;
        margin-right: auto;
        height: 100dvh;
    }
    .root .-content {
        flex-grow: 1;
    }

    .root .-footer {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 32px;
    }
    .root .-footer img {
        height: 28px;
        margin-bottom: 4px;
        opacity: 0.6;
    }
    .root .-footer a {
        font-size: 15px;
        color: blue;
        text-decoration: underline;
        opacity: 0.6;
    }

    .appointment {
        text-align: center;
    }
    .appointment .item {
        display: flex;
        flex-direction: column;
    }
    .appointment .item .label {
        margin-right: 4px;
    }
    .appointment .item .value {
        color: blue;
    }
</style>
